/**
 * JavaScript Utility - number/randomInt
 * @author 서명환 <mhseo@ulalalab.com>
 */
function randomInt(from, to) {
  return Math.floor(Math.random() * (to - from + 1) + from);
}

export default randomInt;
